import React from 'react';
export const PlusCalculator = _ref => {
  let {
    color1 = '#2AB6B9',
    color2 = '#202020',
    size = '30'
  } = _ref;
  return React.createElement("svg", {
    width: size,
    height: size,
    fill: "none",
    viewBox: "-3 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    x: "0.375",
    y: "0.375",
    width: "21.75",
    height: "29.25",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "3.375",
    y: "3.375",
    width: "15.75",
    height: "5.25",
    stroke: color1,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "3.375",
    y: "10.875",
    width: "3.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "15.375",
    y: "10.875",
    width: "3.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "9.375",
    y: "10.875",
    width: "3.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "3.375",
    y: "16.875",
    width: "3.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "9.375",
    y: "16.875",
    width: "3.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "3.375",
    y: "22.875",
    width: "9.75",
    height: "3.75",
    stroke: color2,
    strokeWidth: "0.75"
  }), React.createElement("rect", {
    x: "15.375",
    y: "16.875",
    width: "3.75",
    height: "9.75",
    stroke: color2,
    strokeWidth: "0.75"
  }));
};